import { render, staticRenderFns } from "./TenantSettingsPage.vue?vue&type=template&id=74709b32&"
import script from "./TenantSettingsPage.vue?vue&type=script&lang=ts&"
export * from "./TenantSettingsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports